import { getTimeInputFromTimestamp } from '../../../utilities/get-time-input-from-timestamp';
import { EMPTY_LINK_DATA, LINKS_EMPTY_VALUES, LINK_TYPES } from '../constants';
import { unflattenFieldArray } from './transform-field-array';

const transformLinksForForm = (existingLink) => {
  if (existingLink.links?.length) {
    return existingLink.links;
  }

  // Fallback for legacy links that don't have multiple urls
  // TODO: This can be removed after we migrate all of the links to the honeycomb schema
  if (existingLink.url) {
    return [{ ...EMPTY_LINK_DATA, url: existingLink.url }];
  }

  return [{ ...EMPTY_LINK_DATA }];
};

export const transformLinkDataForForm = (existingLink) => {
  return existingLink
    ? {
        ...existingLink,
        linkType: existingLink.linkType ?? LINK_TYPES.LINK,
        links: transformLinksForForm(existingLink),
        imageUrl: existingLink.image?.url ?? '',
        displayLabel: existingLink.displayLabel ?? '',
        relevance: existingLink.relevance ?? '',
        startTime: getTimeInputFromTimestamp(existingLink.startDate),
        tags: unflattenFieldArray(existingLink.tags),
        filters: unflattenFieldArray(existingLink.filters),
        personalisationTags: unflattenFieldArray(
          existingLink.personalisationTags
        ),
      }
    : LINKS_EMPTY_VALUES;
};
